import { AsyncPipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FooterFacade } from '../data-access/footer.facade';
import { FooterContactComponent } from '../ui-footer-contact/footer-contact.component';
import { LegalLinksComponent } from '../ui-legal-links/legal-links.component';
import { QuickSearchComponent } from '../ui-quick-search/quick-search.component';
import { SiteLinksComponent } from '../ui-site-links/site-links.component';

@Component({
  selector: 'rma-footer',
  imports: [FooterContactComponent, SiteLinksComponent, LegalLinksComponent, QuickSearchComponent, AsyncPipe],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    class: 'flex flex-col gap-4 pb-4 px-4 2xl:px-0',
  },
})
export class FooterComponent {
  private readonly footerFacade = inject(FooterFacade);

  protected readonly communitySiteLinks$ = this.footerFacade.getCommunitySiteLinks();
  protected readonly contactDetails$ = this.footerFacade.getContactDetails();
  protected readonly hasFinance$ = this.footerFacade.hasFinance$;
  protected readonly hasLeasing$ = this.footerFacade.hasLeasing$;
  protected readonly legalLinks$ = this.footerFacade.getLegalLinks();
  protected readonly siteLinkGroups$ = this.footerFacade.getSiteLinks();
  protected readonly sitemapLinks$ = this.footerFacade.locationLinks$;
  protected readonly socialLinks = this.footerFacade.socialLinks;
}
